/**
 * Consentimiento de cookies — fuente única (cookie propia `bison_consent`).
 * Formato: `v1.a<0|1>.m<0|1>` (analítica, marketing). Las necesarias no se almacenan.
 * Lo consumen ConsentManager (banner + carga de GTM) y la política /cookies.
 */

export const CONSENT_COOKIE = 'bison_consent';
export const CONSENT_MAX_AGE = 60 * 60 * 24 * 365; // 12 meses
export const CONSENT_OPEN_EVENT = 'bison:open-consent';

export function serializeConsent({ analytics, marketing }) {
  return `v1.a${analytics ? 1 : 0}.m${marketing ? 1 : 0}`;
}

export function parseConsent(raw) {
  const m = /^v1\.a([01])\.m([01])$/.exec(raw || '');
  return m ? { analytics: m[1] === '1', marketing: m[2] === '1' } : null;
}

export function readConsent() {
  const hit = document.cookie.split('; ').find((c) => c.startsWith(`${CONSENT_COOKIE}=`));
  return hit ? parseConsent(hit.slice(CONSENT_COOKIE.length + 1)) : null;
}

export function writeConsent(consent) {
  document.cookie = `${CONSENT_COOKIE}=${serializeConsent(consent)}; max-age=${CONSENT_MAX_AGE}; path=/; SameSite=Lax${
    location.protocol === 'https:' ? '; Secure' : ''
  }`;
}
